import MobileBottomNav from '@/components/mobile/mobile-bottom-nav';
import { useMyVariables } from '@/hooks/queries/variables/variables-v2';
import { useResetIosZoom } from '@/hooks/useResetIosZoom';
import { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useMediaQuery } from 'usehooks-ts';
import { DashboardSidebar } from '../../components/sidebar/dashboard-sidebar';
import Header from './components/header';

const Dashboard = () => {
  useMyVariables();
  const isMobile = useMediaQuery('(max-width: 768px)');
  const location = useLocation();
  const mainRef = useRef<HTMLElement>(null);

  useResetIosZoom();

  const normalizedPath = location.pathname.replace(/\/$/, '');
  const isOnChatPage = /\/run$/.test(normalizedPath);
  // The analytics dashboard iframe scrolls itself; the page around it must not.
  const isOnAnalyticsDashboard = /^\/[^/]+\/dashboard$/.test(normalizedPath);
  const fillsMain = isOnChatPage || isOnAnalyticsDashboard;

  // Reset scroll position when navigating to a new page
  useEffect(() => {
    if (mainRef.current) {
      mainRef.current.scrollTop = 0;
    }
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    // Use CSS variable --vh for reliable mobile viewport height
    <div
      className="flex overflow-hidden bg-background"
      style={{ height: 'calc(var(--vh, 1vh) * 100)' }}
    >
      {/* Sidebar - starts from top (hidden on mobile) */}
      {!isMobile && <DashboardSidebar />}

      {/* Main content area */}
      <div className="flex flex-1 flex-col overflow-hidden">
        {/* Header - always visible including on mobile chat page */}
        <Header />

        {/* Main content - mt-[72px] accounts for fixed header (64px) + buffer on mobile */}
        <main
          ref={mainRef}
          className={`flex-1 flex flex-col overflow-hidden pb-20 md:pb-0 overflow-y-auto px-2 md:px-0 mt-[72px] md:mt-4`}
        >
          {/* flex-1 gives pages a height to fill, so a full-height loading
              state (h-full / flex-1) centres vertically. It stays a block so
              page roots keep their normal width. */}
          <div
            className={
              fillsMain
                ? 'flex-1 flex flex-col overflow-hidden'
                : 'flex-1 md:px-6'
            }
          >
            <Outlet />
          </div>
        </main>
      </div>

      {/* Mobile Bottom Navigation - always visible on mobile */}
      {isMobile && <MobileBottomNav />}
    </div>
  );
};

export default Dashboard;
